export default "__VITE_ASSET__CudcmEcm__"